<template>
  <div>
    <b-card no-body class="my-0" :class="{ 'card-transparent-background': type == 'add' || type=='edit'}">
      <b-card-header class="card-title-garden-help-default p-2">Service Details</b-card-header>

      <b-card-body class="" :class="{
          'p-2': type == 'profile' ,
          'py-0 pr-0 pl-4': type == 'register' || type == 'add'|| type == 'edit',
        }">
        <div class="">
          <b-row>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help" label="Service type " label-for="service" :service="service"
                label-class="form-label-garden-help">
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_service">
                  Please select at least one service
                </p>
                <v-select v-if="type == 'add' || (type == 'edit' && edit_service)" :options="service_options" v-model="_service"
                  name="service" title="service" placeholder="Choose service" label="name" :reduce="(item) => item.id"
                  :clearable="false" :multiple="true"
                                                    :closeOnSelect="true" required>
                </v-select>
                <span v-else class="form-control form-control-garden-help">
                  {{ _service }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12" v-if="type!='edit'">
              <InputRadio :field_label="'Is this the first time you do service for this property?'"
                :field_model.sync="_first_time_service" :options="first_time_options" name="first_time_service" />
            </b-col>
            <b-col sm="12" v-if="_first_time_service == 0">
              <b-form-group class="form-group-garden-help form-group-datetime-garden-help"
                label="What was the time of the last service?" label-for="last_service_date"
                label-class="form-label-garden-help">
                <date-picker v-if="type == 'add' || type == 'edit'" v-model="_last_service_date" type="date"
                  value-type="YYYY-MM-DD" format="DD MMM YYYY" :partial-update="true" :confirm="false"
                  :disabled-date="notAfterToday"
                  popup-class="datetime-picker-garden-help" input-class="form-control form-control-garden-help w-100" :append-to-body="false">
                  <template v-slot:icon-calendar><img src="@/assets/images/garden-help/calendar-icon-input.png" />
                  </template>
                </date-picker>
                <span v-if="type == 'view'" class="form-control form-control-garden-help">
                  {{ _last_service_date }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help form-group-datetime-garden-help" label="Booking date"
                label-for="booking_date" label-class="form-label-garden-help">
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_booking_date">
                  Please select date
                </p>
                <date-picker v-model="_booking_date" 
                type="datetime"
                  value-type="YYYY-MM-DD HH:mm" format="DD MMM YYYY, hh:mm a" 
                  :partial-update="true" :confirm="true"
                  :disabled-date="notBeforeToday" :disabled-time="notBeforeTodayTime"
                  popup-class="datetime-picker-garden-help" 
                  input-class="form-control form-control-garden-help w-100" :append-to-body="false"
                  required>
                  <template v-slot:icon-calendar><img src="@/assets/images/garden-help/calendar-icon-input.png" />
                  </template>
                </date-picker>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help" label="Short description" label-for="short_description"
                :short_description="short_description" label-class="form-label-garden-help">
                <b-form-textarea v-if="type == 'register' || type == 'add'" id="short_description"
                  class="form-control-garden-help" v-model="_short_description" :short_description="short_description"
                  rows="4" required></b-form-textarea>
                <span v-if="type == 'profile'  || type == 'edit'" class="form-control form-control-garden-help">
                  {{ _short_description }}
                </span>
              </b-form-group>
            </b-col>
            <!-- <b-col sm="12">
              <b-form-group class="form-group-garden-help" label="More details" label-for="more_details"
                :more_details="more_details" label-class="form-label-garden-help">
                <b-form-textarea v-if="type == 'register' || type == 'add' || type == 'edit'" id="more_details"
                  class="form-control-garden-help" v-model="_more_details" :more_details="more_details"
                  rows="4"></b-form-textarea>
                <span v-if="type == 'profile'" class="form-control form-control-garden-help">
                  {{ _more_details }}
                </span>
              </b-form-group>
            </b-col> -->
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import InputRadio from "@/components/Inputs/InputRadio.vue";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "ServiceDetails",
  components: { InputRadio, DatePicker },
  props: [
    "type",
    "service",
    "service_options",
    "invalid_service",
    "first_time_service",
    "last_service_date",
    "booking_date",
    "invalid_booking_date",
    "short_description",
    "more_details",
    "edit_booking_date",
    "edit_service"
  ],
  data() {
    return {
      first_time_options: [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
      ],
    };
  },
  methods: {

    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    notBeforeTodayTime(date) {
      let h = new Date().getHours()
      return date < new Date(new Date().setHours(h + 2, 0, 0, 0));
    },
    notAfterToday(date){
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      return date > new Date(today.getTime() - 1 * 24 * 3600 * 1000);
      // return date > new Date()
    }
  },
  computed: {
    _service: {
      get() {
        return this.service;
      },
      set(value) {
        this.$emit("update:service", value);
      },
    },
    _first_time_service: {
      get() {
        return this.first_time_service;
      },
      set(value) {
        this.$emit("update:first_time_service", value);
      },
    },
    _last_service_date: {
      get() {
        return this.last_service_date;
      },
      set(value) {
        this.$emit("update:last_service_date", value);
      },
    },
    _booking_date: {
      get() {
        return this.booking_date;
      },
      set(value) {
        this.$emit("update:booking_date", value);
      },
    },
    _short_description: {
      get() {
        return this.short_description;
      },
      set(value) {
        this.$emit("update:short_description", value);
      },
    },
    _more_details: {
      get() {
        return this.more_details;
      },
      set(value) {
        this.$emit("update:more_details", value);
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/details_components/ServiceDetails.vue